// src/utils/userDisplay.ts
// Iniciales para el avatar del menú de usuario (mismo patrón que la agenda dental).

export const getInitials = (firstname?: string, lastname?: string): string => {
  const initials = [firstname, lastname]
    .map((w) => (w || '').trim()[0])
    .filter(Boolean)
    .join('')
    .toUpperCase();
  return initials || '?';
};
